exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-2bef3042]{color:#000}h2[data-v-2bef3042]{color:#000;margin-top:50px}.center[data-v-2bef3042]{text-align:center}.buttons[data-v-2bef3042]{justify-content:center}a>img[data-v-2bef3042]{margin-top:50px;box-shadow:10px 5px 5px #d3d3d3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bef3042","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FinishExam.vue
// module id = 205
// module chunks = 0